import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField';
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import Icon from 'material-ui/Icon'

import { ModalHeader, ModalContents, ModalFooter } from '../common/modal'

import { validateFormData } from '../../common/formtool'

import withRole from '../hoc/role'
import {
  ROLES_IDEAL_ADMIN,
  ROLES_IDEAL_SUPPORT,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER,
  ROLES_CLIENT
} from '../../common/constants'

const IdealAdminRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value} />}
      autoWidth={false}
    >
      <MenuItem value="idealadmin">{props.translate("idealadmin")}</MenuItem>
      <MenuItem value="idealsupport">{props.translate("idealsupport")}</MenuItem>
    </Select>
  )
}, ROLES_IDEAL_ADMIN)

const IdealSupportRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value} />}
      autoWidth={false}
    >
      <MenuItem value="idealadmin">{props.translate("idealadmin")}</MenuItem>
      <MenuItem value="idealsupport">{props.translate("idealsupport")}</MenuItem>
    </Select>
  )
}, ROLES_IDEAL_SUPPORT)

const ClientAdminRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value} />}
      autoWidth={false}
      disabled={props.disableField}
    >
      <MenuItem value="clientadmin">{props.translate("clientadmin")}</MenuItem>
      <MenuItem value="clientmanager">{props.translate("clientmanager")}</MenuItem>
      <MenuItem value="clientuser">{props.translate("clientuser")}</MenuItem>
    </Select>
  )
}, ROLES_CLIENT_ADMIN)

const ClientManagerRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value} />}
      autoWidth={false}
      disabled={props.disableField}
    >
      <MenuItem value="clientmanager">{props.translate("clientmanager")}</MenuItem>
      <MenuItem value="clientuser">{props.translate("clientuser")}</MenuItem>
    </Select>
  )
}, ROLES_CLIENT_MANAGER)


const MeasurementUnitByRole = withRole((props) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  )
}, ROLES_CLIENT)

class User extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      user: {
        firstname: "",
        lastname: "",
        enabled: true,
        language: "",
        email: "",
        roles: [''],
        units: ""
      },
      error: null,
      submit: false,
      disableField: false
    }
    this.onChange = this.onChange.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

  }

  onChange(e) {
    let user = { ...this.state.user }
    let errors = { ...this.state.errors }
    errors = {
      ...errors,
      [e.target.name]: false
    }
    if (e.target.name !== 'roles') {
      user[e.target.name] = e.target.value
    } else {
      user.roles[0] = e.target.value
    }
    this.setState({ user: user, errors })
  }

  handleClose() {
    this.props.close()
    this.setState({
      errors: {},
      user: {
        firstname: "",
        lastname: "",
        enabled: true,
        language: "",
        email: "",
        units: "",
        roles: ['']
      },
      error: null
    })
  }

  handleSubmit() {
    let user = { ...this.state.user }
    let { translate, profile } = this.props
    this.setState({
      submit: true
    }, () => {
      let vObj = {
        email: {
          required: translate("formfield_error_general_required"),
          validEmail: translate('formfield_error_general_email')
        },
        firstname: {
          required: translate("formfield_error_general_required")
        },
        lastname: {
          required: translate("formfield_error_general_required")
        },
        language: {
          required: translate("formfield_error_general_required")
        }
      }
      if (profile.roles != 'idealadmin' && profile.roles != 'idealsupport') {
        vObj['units'] = {
          required: translate("formfield_error_general_required"),
        }
      }
      let errors = validateFormData(this.state.user, vObj);
      if (user.roles[0] === "") {
        errors['roles'] = translate("formfield_error_general_required")
      }
      const missingFieldName = Object.keys(errors)[0]
      if (missingFieldName) {
        const textField = document.getElementsByName(missingFieldName)[0]
        textField && textField.focus()
      }
      if (Object.keys(errors).length) {
        this.setState({ errors: errors })
        this.setState({
          submit: false
        })
      } else {
        let self = this;
        let email = self.state.user.email;
        if (this.props.mode === 'edit') {
          this.props.update(user, this.props.pager).then((resp) => {
            self.handleClose()
            self.props.removedSelectedUserRadioCheck()
          }).catch((err) => {
            if (err.errors === 'error_duplicateuser') {
              self.setState({
                error: {
                  type: 'error_duplicateuser',
                  data: email
                },
                submit: false
              })
            }
          })
        } else {
          this.props.create(user, this.props.pager).then((resp) => {
            self.handleClose()
          }).catch((err) => {
            if (err.errors === 'error_duplicateuser') {
              self.setState({
                error: {
                  type: 'error_duplicateuser',
                  data: email
                }
              })
            }
          })
        }
      }
    })

  }
  getModalError(error) {
    if (error.type === "error_duplicateuser") {
      return (
        <div className={this.props.classes.error}>
          <Typography type="subheading" color="inherit">
            {this.props.translate('error_duplicateuser_title')}
          </Typography>
          <Typography type="body1" color="inherit">
            {this.props.translate('error_duplicateuser_desc', { email: error.data })}
          </Typography>
        </div>
      )
    }
  }
  render() {
    const {
      translate,
      languages,
      classes,
      mode
    } = this.props

    const {
      user,
      errors,
      error,
      disableField
    } = this.state

    return (
      <Modal open={this.props.modal} onClose={this.handleClose.bind(this)}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit" className={classes.modalHeader}>
                {mode === 'edit' ? translate('user_title_edit') : translate('user_title_add')}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              {error && this.getModalError(error)}
              <form noValidate autoComplete="off" className={classes.form}>
                <TextField
                  required
                  error={errors.email ? true : false}
                  name="email"
                  label={translate("user_email")}
                  margin="normal"
                  fullWidth
                  value={user.email}
                  onChange={this.onChange}
                  helperText={errors.email ? errors.email : translate("user_email_help")}
                  disabled={mode === 'edit'}
                />
                <TextField
                  required
                  error={errors.firstname ? true : false}
                  name="firstname"
                  label={translate("user_firstname")}
                  margin="normal"
                  fullWidth
                  value={user.firstname}
                  onChange={this.onChange}
                  helperText={errors.firstname ? errors.firstname : translate("user_firstname_help")}
                  disabled={disableField}
                />
                <TextField
                  required
                  error={errors.lastname ? true : false}
                  name="lastname"
                  label={translate("user_lastname")}
                  margin="normal"
                  fullWidth
                  value={user.lastname}
                  onChange={this.onChange}
                  helperText={errors.lastname ? errors.lastname : translate("user_lastname_help")}
                  disabled={disableField}
                />
                <FormControl
                  fullWidth
                  margin="normal"
                  required
                  error={errors.roles ? true : false}
                >
                  <InputLabel htmlFor="roles">{translate("user_roles")}</InputLabel>
                  <IdealAdminRoleSelect onChange={this.onChange} value={user.roles[0]} translate={translate} disableField={disableField} />
                  <IdealSupportRoleSelect onChange={this.onChange} value={user.roles[0]} translate={translate} disableField={disableField} />
                  <ClientAdminRoleSelect onChange={this.onChange} value={user.roles[0]} translate={translate} disableField={disableField} />
                  <ClientManagerRoleSelect onChange={this.onChange} value={user.roles[0]} translate={translate} disableField={disableField} />
                  <FormHelperText>{errors.roles ? errors.roles : translate("user_roles_help")}</FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  required
                  margin="normal"
                  error={errors.language ? true : false}
                >
                  <InputLabel htmlFor="language">{translate("user_language")}</InputLabel>
                  <Select
                    value={user.language}
                    onChange={this.onChange}
                    input={<Input name="language" id="language" value={user.language} />}
                    autoWidth={false}
                    disabled={disableField}
                  >
                    {
                      languages.map((language, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={language.code}
                          >
                            {language.code}
                          </MenuItem>
                        )
                      })
                    }
                  </Select>
                  <FormHelperText>{errors.language ? errors.language : translate("user_language_help")}</FormHelperText>
                </FormControl>
                <MeasurementUnitByRole>
                  <FormControl
                    fullWidth
                    required
                    margin="normal"
                    error={errors.units ? true : false}
                  >
                    <InputLabel htmlFor="metric">{translate("user_metric")}</InputLabel>
                    <Select
                      value={user.units}
                      onChange={this.onChange}
                      input={<Input name="units" id="units" value={user.units} />}
                      autoWidth={false}
                      disabled={disableField}
                    >
                      <MenuItem
                        value={'feet'}
                      >
                        {translate("user_metric_feet")}
                      </MenuItem>
                      <MenuItem
                        value={'meters'}
                      >
                        {translate("user_metric_meter")}
                      </MenuItem>
                    </Select>
                    <FormHelperText>{errors.units ? errors.units : translate("user_metric_help")}</FormHelperText>
                  </FormControl>
                </MeasurementUnitByRole>
              </form>
            </ModalContents>
            <ModalFooter>

              <Button raised
                color="accent"
                className={classes.submit}
                onClick={this.handleSubmit}
                type="submit"
                disabled={disableField}
              >
                {translate('general_submit')}
              </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
  componentWillReceiveProps(nextProps) {
    const { submit } = this.state
    if (nextProps.user && !submit) {
      if ((nextProps.user.roles && nextProps.user.roles[0] === "clientadmin") && (nextProps.profile.roles === "clientmanager")) {
        this.setState({
          disableField: true
        })
      }
      if (nextProps.profile.roles === "idealadmin" && nextProps.user.errors === "error_no_permission") { // when login using supportUser account
        return this.setState({
          user: {
            firstname: "",
            lastname: "",
            enabled: true,
            language: "",
            email: "",
            roles: [''],
            units: ""
          }
        })
      }
      return this.setState({
        user: { ...nextProps.user }
      })
    }
  }

  componentWillMount() {
    if (this.props.user) {
      this.props.reset()
    }
  }
}
export default withStyles(styles)(User)
